import React, { Component } from 'react';
import { connect } from "react-redux";
import ModalGeneTestForm from './modal-gene-test-form'

import genetic_testing_api from '../api/genetic-testing-api'
import * as static_list_actions from '../store/static_list/actions'
import * as patient_actions from '../store/patient/actions';
import geneResults from '../assets/json/gene-result.json'
import geneStatus from '../assets/json/gene-status.json'
import { cloneDeep, isEmpty } from "lodash";
import { createUUID } from './react-flow-pedigree/utils';

import ModalConfirmDelete from './modal-confirm-delete';

class PatientGeneTestView extends Component {

  constructor(props) {
    super(props)
    this.state = {
      showModalGeneTest: false,
      selectedGeneDetail: null,
      modalGeneTestTitle: '',
      openModalConfirmDelete: false,
      modalConfirmDeleteHash: null,
      loading_delete: false,
      errorMessages: []
    }

    this.handleClickAddGeneTest = this.handleClickAddGeneTest.bind(this)
    this.handleEditGeneTest = this.handleEditGeneTest.bind(this)
    this.disableAddForReadOnly = this.disableAddForReadOnly.bind(this)
    this.getGeneTests = this.getGeneTests.bind(this)
    this.getGenePanels = this.getGenePanels.bind(this)
    this.getPanelName = this.getPanelName.bind(this)
    this.renderGenes = this.renderGenes.bind(this)
  }

  async componentDidMount() {
    // await this.loadGeneticTestingsFromAPI()
  }

  async loadGeneticTestingsFromAPI() {
    try {
      let genetic_testings = this.props.static_list.genetic_testings;
      if(genetic_testings.length == 0) {
        let data = await genetic_testing_api.get_genetic_testing();
        genetic_testings = data.sort((a, b) => {
          if(a.gene < b.gene) return -1;
          if(a.gene > b.gene) return 1;
          return 0;
        });
        this.props.dispatch(static_list_actions.initialize_genetic_testings(genetic_testings));
      }

    } catch (error) {
      console.log(error)
    }
  }


  async handleClickAddGeneTest() {
    if('onBeforeAddGene' in this.props) {
      var ok = await this.props.onBeforeAddGene();
      if(ok) {
        this.setState({showModalGeneTest: true, selectedGeneDetail: null, modalGeneTestTitle: 'Add Gene'})
      }
    } else {
      this.setState({showModalGeneTest: true, selectedGeneDetail: null, modalGeneTestTitle: 'Add Gene'})
    }
  }

  getGeneTests() {
    let history_genes = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().genes : this.props.history_genes
    if(this.props.patientRkey in history_genes) {
      let geneTests = history_genes[this.props.patientRkey];
      let genesDisplay = [];
      for(let test of geneTests) {
        if(test.rkey === null || test.rkey === undefined) test.rkey = createUUID();
        if('member_genes' in test) continue;
        genesDisplay.push(test);
      }
      return genesDisplay;
    }
    return []
  }

  diseaseGroup(id) {
    if(1 <= id <= 43) {
      return 'Cancer';
    } else {
      return 'Other Conditions';
    }
  }

  handleEditGeneTest(selectedGeneDetail) {
    this.setState({showModalGeneTest: true, selectedGeneDetail, modalGeneTestTitle: 'Edit Gene'})
  }


  getLabelResult(id) {
    if(geneResults.length == 0) return '';
    var result = geneResults.find(item => item.value == id || item.label == id)

    if(typeof(result) === 'undefined') return ''
    return result.label;
  }

  getLabelStatus(id) {
    if(geneStatus.length == 0) return '';
    var status = geneStatus.find(item => item.value == id)

    if(typeof(status) === 'undefined') return ''
    return status.label;
  }

  onModalGeneTestSave(data) {
    let patient_rkey = data.rkey;
    let gene_rkey = data.gene.rkey;
    let new_gene = data.gene;
    let testing_panel = data.gene.testing_panel ? data.gene.testing_panel : null

    if (this.props.getPedigreeData !== undefined && this.props.getPedigreeData !== null) {
      const profile = this.props.getPedigreeData().getProfile(patient_rkey);
      let genes = cloneDeep(this.props.getPedigreeData().getGenes(patient_rkey))
      let gene_panels = cloneDeep(this.props.getPedigreeData().getGenePanels(patient_rkey))
      if (new_gene && 'panel_id' in new_gene) {
        if (gene_panels) {
          let index = gene_panels.findIndex(panel => panel.rkey === gene_rkey)
          if (index > -1) {
            gene_panels[index] = new_gene
          } else {
            gene_panels.push(new_gene)
          }
          profile.gene_panels = gene_panels;
          this.props.getPedigreeData().setGenePanels(patient_rkey, gene_panels)
        } else {
          const g = [new_gene];
          profile.gene_panels = g;
          this.props.getPedigreeData().setGenePanels(patient_rkey, g)
        }
        this.props.getPedigreeData().setProfile(patient_rkey, profile)
      } else {
        if (genes) {
          let index = genes.findIndex(gene => gene.rkey === gene_rkey)
          if (index > -1) {
            genes[index] = new_gene
          } else {
            genes.push(new_gene)
          }

          profile.genetic_testing = genes;
          this.props.getPedigreeData().setGenes(patient_rkey, genes)
        } else {
          const g = [new_gene];
          profile.genetic_testing = g;
          this.props.getPedigreeData().setGenes(patient_rkey, g)
        }
        this.props.getPedigreeData().setProfile(patient_rkey, profile)
      }
    } else {
      if (testing_panel) {
        this.props.dispatch(patient_actions.save_history_gene_panel_detail({
          ownerRkey: patient_rkey,
          history_gene_detail: new_gene
        }));
        const history_genes = this.props.history_genes[patient_rkey] ? this.props.history_genes[patient_rkey] : []
        // need to check if testing panel was previously a non panel and delete record
        const record_exists = history_genes.find(gene => gene.rkey === gene_rkey)
        if (record_exists) {
          this.props.dispatch(patient_actions.delete_history_gene_detail({
            ownerRkey: patient_rkey,
            history_gene_detail: gene_rkey
          }));
        }
      } else {
        this.props.dispatch(patient_actions.save_history_gene_detail({
          ownerRkey: patient_rkey,
          history_gene_detail: new_gene
        }));
      }
    }

    //if('onGeneTestUpdate' in this.props) this.props.onGeneTestUpdate(data);
    this.setState({showModalGeneTest: false});
  }

  onModalGeneTestDelete(data) {
    //if('onGeneTestUpdate' in this.props) this.props.onGeneTestUpdate(data);
    this.setState({showModalGeneTest: false});
    if(this.state.openModalConfirmDelete === true) this.setState({openModalConfirmDelete: false})
  }

  onClickOpenModalConfirmDelete(selectedGeneDetail) {
    this.setState({
      selectedGeneDetail,
      openModalConfirmDelete: true,
      modalConfirmDeleteHash: new Date().getTime()
    });
  }

  async onClickDelete() {
    try {
      this.setState({ errorMessages: [], loading_delete: true })

      let genePayload = {}
      let gene_rkey = this.state.selectedGeneDetail.rkey ? this.state.selectedGeneDetail.rkey : null
      let testing_panel = this.state.selectedGeneDetail.testing_panel ? this.state.selectedGeneDetail.testing_panel : null
      // delete gene panel
      if(testing_panel) {
        genePayload = {
          member_id: this.state.selectedGeneDetail.member_id,
          gene_rkey: gene_rkey ? gene_rkey : null,
          testing_panel: testing_panel ? testing_panel : null
        }
        await genetic_testing_api.delete_member_gene_panel(genePayload)
      }
      // delete genetic testing
      else if(this.state.selectedGeneDetail.id !== null) {
        await genetic_testing_api.delete_member_genetic_testing_id(this.state.selectedGeneDetail.id)
      }

      if(this.props.getPedigreeData !== undefined && this.props.getPedigreeData !== null){
        let genes = cloneDeep(this.props.getPedigreeData().getGenes(this.props.patientRkey))
        let gene_panels = cloneDeep(this.props.getPedigreeData().getGenePanels(this.props.patientRkey))
        let profile_proband = cloneDeep(this.props.getPedigreeData().getProfile(this.props.patientRkey))

        if (testing_panel) {
          gene_panels = gene_panels.filter(panel => panel.rkey !== gene_rkey)
          profile_proband.gene_panels = gene_panels;
          this.props.getPedigreeData().setGenePanels(this.props.patientRkey, gene_panels)
        } else if (gene_rkey) {
          genes = genes.filter(gene => gene.id !== this.state.selectedGeneDetail.id)
          profile_proband.genetic_testing = genes;
          this.props.getPedigreeData().setGenes(this.props.patientRkey, genes)
        }

        this.props.getPedigreeData().setProfile(this.props.patientRkey, profile_proband)
      }
      else{
        if (testing_panel) {
          this.props.dispatch(patient_actions.delete_history_gene_panel_detail({
            ownerRkey: this.props.patientRkey,
            gene_panel_rkey: gene_rkey
          }));
        } else {
          this.props.dispatch(patient_actions.delete_history_gene_detail({
            ownerRkey: this.props.patientRkey,
            gene_detail_rkey: gene_rkey
          }));
        }
      }



      if('onGeneTestUpdate' in this.props) {
        this.onModalGeneTestDelete()
      } else {
        this.setState({showModalGeneTest: false})
      }

    } catch (error) {
      this.setState({ errorMessages: [error.message] })
    } finally {
      this.setState({ loading_delete: false })
    }
    this.setState({openModalConfirmDelete: false})
  }

  disableAddForReadOnly(){
    if(this.props.read_only && this.props.read_only === true){
      return false
    }
    return true
  }


  getGenePanels() {
    let history_genes = this.props.getPedigreeData !== null && this.props.getPedigreeData !== undefined ? this.props.getPedigreeData().genePanels : this.props.history_gene_panels
    if(this.props.patientRkey in history_genes) {
      let geneTests = history_genes[this.props.patientRkey];
      let genePanelsDisplay = [];
      for(let test of geneTests) {
        if(test.rkey === null || test.rkey === undefined) test.rkey = createUUID();
        if('member_genes' in test) genePanelsDisplay.push(test);
      }
      return genePanelsDisplay;
    }
    return []
  }
  getPanelName(panelId) {
    const panels = this.props.static_list.genetic_testin_panels;
    if (!panels) return panelId;
  
    const panel = panels[panelId];
    if (panel && panel.labs) {
      let lab = Object.values(this.props.static_list.genetic_testings_labs).find(
        (lab) => lab.id === panel.labs
      );
      let lab_name = null;
      if (lab) {
        lab_name = lab.lab
        return lab_name + ' - ' + panel.panel_name;
      }
    }
    return panel?.panel_name || panelId;
  }

  renderGenes(){
    const geneTests = this.getGenePanels();
  
    if(isEmpty(geneTests)) return <> </>
        return Object.keys(geneTests).map(key => {
            const { member_genes: tests, panel_status, panel_id, panel_notes, panel_tested } = geneTests[key];
            const is_pending = panel_status === 'pending';
            const panel_name = panel_tested ? panel_tested.testing_lab.lab + ' - ' + panel_tested.panel_name : this.getPanelName(panel_id);
            
            const nonNegativeResults = Object.values(tests).filter(
              ({ result }) => result && result !== 'n' && result !== 'Negative'
            );
            const noResults = Object.values(tests).every(
              ({ result }) => !result
            );
  
            return (panel_name !== '' && panel_name !== undefined && panel_name !== null) ? (
                <div 
                  className={`panel-summary ${this.props.sideBar ? 'width--full' : ''}`}
                >
                  {this.disableAddForReadOnly() && (
                    <div className="panel-summary-actions">
                      <a 
                        className="panel-summary-edit" 
                        onClick={() => this.handleEditGeneTest(geneTests[key])}
                      >
                        <i className="fa fa-pencil-square-o"></i>
                      </a>
                      <a 
                        className="panel-summary-delete" 
                        onClick={() => this.onClickOpenModalConfirmDelete(geneTests[key])}
                      >
                        <i className="fa fa-trash"></i>
                      </a>
                    </div>
                  )}
    
                  <h4>{panel_name}</h4>
  
                  {nonNegativeResults.length > 0 ? (
                          nonNegativeResults.map(({ hash_id, gene, umls_name, result, variant, status }, index) => (
                            <p key={hash_id}>
                              <b> {gene || umls_name} </b> - {this.getLabelResult(result)}
                              {variant && this.getLabelResult(result) ? `, ${variant}` : `${variant}`}
                              {this.getLabelStatus(status) ? (this.getLabelResult(result) || variant ? ', ' + this.getLabelStatus(status) : this.getLabelStatus(status)) : null}
                            </p>
                        ))
                    ) : (panel_status === 'canceled' && noResults) ? (
                      <p> Canceled </p>
                    ) :(is_pending || noResults ) ? (
                      <p> Pending </p>
                    ) :  (
                      <p>Negative Genetic Testing</p>
                    )}
  
                    {panel_notes && <p>{panel_notes}</p>}
  
                </div>
    
            ) : (
              <div 
              className={`panel-summary ${this.props.sideBar ? 'width--full' : ''}`}
              >
                  {this.disableAddForReadOnly() && (
                    <div className="panel-summary-actions">
                      <a 
                        className="panel-summary-edit" 
                        onClick={() => this.handleEditGeneTest(geneTests[key])}
                      >
                        <i className="fa fa-pencil-square-o"></i>
                      </a>
                      <a 
                        className="panel-summary-delete" 
                        onClick={() => this.onClickOpenModalConfirmDelete(geneTests[key])}
                      >
                        <i className="fa fa-trash"></i>
                      </a>
                    </div>
                  )}              
                {Object.values(tests).map((gene, index, array) => (
                    <p>
                      <b>{gene.umls_name || gene.gene}</b> - {this.getLabelResult(gene.result)}
                      {gene.variant && this.getLabelResult(gene.result) ? `, ${gene.variant}` : `${gene.variant}`}
                      {this.getLabelStatus(gene.status) ? (this.getLabelResult(gene.result) || gene.variant ? ', ' + this.getLabelStatus(gene.status) : this.getLabelStatus(gene.status)) : null}
                    </p>
                ))}
  
                {panel_notes && <p>{panel_notes}</p>}              
  
              </div>
              
              )
      });
    }
  
  render() {
    return (
      <React.Fragment>
        <div className="row col-md-6 pull-right margin-one" style={{paddingRight: "2%"}}>
          <div className="col-md-12 margin-one no-margin-top">
            <div className={(this.props.sideBar ? "form-header-2" : "form-header")}>
              <div className="row vcenter">
                <div className="col-md-6 ">
                <h3 className={"title " + (this.props.sideBar ? 'text--uppercase' : '')}>Genetic Testing</h3>
                </div>
              {this.disableAddForReadOnly() && (
                <div className="col-md-6 ">

                  {this.props.sideBar ?
                    <a className="btn btn-teal btn-xs" onClick={this.handleClickAddGeneTest}><i className="fa fa-plus"></i> Add</a>
                  :
                    <a id="add-gene-btn" className="btn btn-teal btn-xs" onClick={this.handleClickAddGeneTest}><i className="fa fa-plus"></i> Add</a>
                  }

                </div>
              )}
              </div>
            </div>
            <div className="panel-col-gene">
              {this.renderGenes()}
              {this.getGeneTests().map((item, index, array) => (
                <div key={item.rkey} className={"panel-summary " + (this.props.sideBar ? 'width--full' : '')}>
                {this.disableAddForReadOnly() && (
                  <>
                  <a className="panel-summary-edit" onClick={() => this.handleEditGeneTest(item)}><i className="fa fa-pencil-square-o"></i></a>
                  <a className="panel-summary-delete" onClick={() => this.onClickOpenModalConfirmDelete(item)}><i className="fa fa-trash"></i></a>
                  </>
                )}
                  <p>
                    <b>{item.gene || item.umls_name}</b> - {this.getLabelResult(item.result)}
                    {item.variant && this.getLabelResult(item.result) ? `, ${item.variant}` : `${item.variant}`}
                    {this.getLabelStatus(item.status) ? (this.getLabelResult(item.result) || item.variant ? ', ' + this.getLabelStatus(item.status) : this.getLabelStatus(item.status)) : null}
                  </p>
                </div>
              ))}

            </div>
          </div>
        </div>

        {this.state.openModalConfirmDelete &&
          <ModalConfirmDelete
            title="Delete Gene"
            message="Do you want to delete this gene?"
            isOpen={this.state.openModalConfirmDelete}
            onCancel={() => this.setState({ openModalConfirmDelete: false })}
            onOk={() => this.onClickDelete()}
            loading={this.state.loading_delete}
            errorMessages={this.state.errorMessages}
          />
        }

        {this.state.showModalGeneTest &&
          <ModalGeneTestForm
            title={this.state.modalGeneTestTitle}
            patientRkey={this.props.patientRkey}
            profile={this.props.profile}
            geneDetail={this.state.selectedGeneDetail}
            onClose={() => this.setState({showModalGeneTest: false})}
            onCancel={() => this.setState({showModalGeneTest: false})}
            onSave={(data) => this.onModalGeneTestSave(data)}
            onDelete={() => this.onModalGeneTestDelete()}
            getPedigreeData={this.props.getPedigreeData}
          />
        }



      </React.Fragment>
    )
  }
}

const redux_state = state => ({
  history_diseases: state.patient.history_diseases,
  history_genes: state.patient.history_genes,
  history_gene_panels: state.patient.history_gene_panels,
  static_list: state.static_list
});

const redux_actions = dispatch => ({
  dispatch: (action) => dispatch(action)
});

export default connect(redux_state, redux_actions)(PatientGeneTestView);
